module.exports = __webpack_public_path__ + "img/MDL_DM.7dfb9849.png";